import React, {Fragment, ReactElement, useEffect} from 'react';
import {
  setAppBarTitle,
  setBackNavAction,
  setBackNavEnabled,
} from '../../../redux/globalSlice';
import {useAppDispatch, useAppSelector} from '../../../redux/hooks';
import {useState} from 'react';
import {BackButtonAction} from '../../../core/utils/string.util';
import exclamation from '../../../assets/images/exclamation.svg';
import {useHistory} from 'react-router-dom';
import {
  resetState,
  arrangeMissingSizeData,
  missingSizeOrderedInfo,
  productSizeData,
  MissingSizeData,
} from '../../../redux/missingSizeApiSlice';
import {getSize, setColor, setSize} from '../../../core/localstorage-data';
import {WebsiteUrl} from '../../../lib/constants';
import { referral_eCommerce, selectColor } from '../../../lib/tagmanager';
const SelectColor = (): ReactElement => {
  const navigate = useHistory();
  const size = getSize();
  const colorDetail: string[] = [];
  const missingSizeDetail = useAppSelector(missingSizeOrderedInfo);
  const [selectedColor, setSelectedColor] = useState<string | null>(null);
  const [checkColorAvailability, setColorAvalibility] = useState(true);
  const dispatch = useAppDispatch();
  const productSearchData = useAppSelector(productSizeData);
  const missingSizeApiData = useAppSelector(MissingSizeData);
  //add size variable and get the value from localstorage
  //const size=getSize();
  //first address this
  useEffect(() => {
    if (size === null) {
      navigate.replace('missingsizes');
    }
    if (missingSizeDetail === undefined) {
      navigate.replace('missingsizes');
    }
  }, [missingSizeDetail]);
  for (const sizes in missingSizeDetail?.colorsBySize) {
    //  console.log(sizes);
    if (sizes === size) {
      const colors = missingSizeDetail?.colorsBySize[sizes];
      console.log(colors);
      colors.map((color: any) => colorDetail.push(color));
      break;
    }
  }

  // (missingSizeDetail?.colorsBySize as Map<string, string[]>).forEach(
  //   (colors, sizes) => {
  //     console.log(sizes);

  //     if (sizes === size) {
  //       //      console.log('selected size', size);
  //       //    console.log(colors);
  //       colors.forEach(color => colorDetail.push(color));
  //       return;
  //     }
  //   },
  // );

  useEffect(() => {
    dispatch(setAppBarTitle('Find missing size'));
    dispatch(setBackNavEnabled(true));
    //add it to missing size
    dispatch(setBackNavAction(BackButtonAction.TO_MISSING_SIZE));

    return () => {
      // Clean up the subscription
      dispatch(setAppBarTitle(''));
      dispatch(setBackNavEnabled(false));
      // dispatch(setBackNavAction(undefined));
    };
  }, [setAppBarTitle]);

  const selectSizeHandler = (color: string) => {
    setSelectedColor(color);
    setColorAvalibility(false);
  };
  const buttonHandler = () => {
    let code = '';
    for (const color in missingSizeDetail?.productByCode) {
      //const element = missingSizeDetail.productByCode[color];
      //console.log(element);
      if (color == selectedColor) {
        const element = missingSizeDetail?.productByCode[color];
        element.map((variant: any) => {
          if (variant.size == size) {
            code = variant.code;
            selectColor(variant.code,variant.size,productSearchData.color,missingSizeApiData.price.value,missingSizeApiData.name,variant.stock.stockLevelStatus);
          }
        });
        console.log(element);
        // if (element.size == selectedSize) {
        //   console.log(element.code);
        //   code = element.code;
        // }
      }

      console.log(color);
      // console.log(element);
    }
    referral_eCommerce(`${WebsiteUrl}'p/'${code}/?utm_source=buddy.maxfashion.in&utm_medium=referral&utm_campaign=missing_sizes`)
    window.open(WebsiteUrl + 'p/' + code, '_blank', 'noreferrer');

    // navigate.push('/home');
  };
  const ThanksHandler = () => {
    //navigate to thank you with size,color
    if (missingSizeDetail?.productColor?.color != undefined) {
      setColor(missingSizeDetail.productColor?.color);
    }
    if (size != undefined) {
      setSize(size);
    }
    selectColor(productSearchData.base_product,size,missingSizeDetail?.productColor?.color,missingSizeApiData.price.value,missingSizeApiData.name,"outOfStock")
    navigate.replace('notify');
    //notify(size, missingSizeDetail?.productColor?.color);
  };
  return (
    <Fragment>
      <div className="container mx-auto z-10 p-4 bg-color">
        <div className="w-auto ">
          <div className=" grid place-items-center">
            <img src={exclamation} />
          </div>
          <div className="mt-6 grid place-items-center">
            <span className="font-roboto text-2xl text-center">
              Thank you for your interest!
            </span>
          </div>
          <div className="mt-2 grid place-items-center">
            <span className="font-roboto font-thin text-center">
              <span className="text-black text-opacity-50">Size</span> &lsquo;
              <span className="font-medium">{size}</span>&lsquo;
              <span className="text-black text-opacity-50">
                {' '}
                is not available in this colour.
              </span>
            </span>
          </div>
          <div className="font-roboto font-thin text-center">
            <span className="text-black text-opacity-50 ">
              We have it in other colour(s)
            </span>
          </div>
          <div className="mt-12 flex-wrap">
            {colorDetail.map((color, index) => (
              <button
                key={index}
                onClick={() => selectSizeHandler(color)}
                className={`w-auto h-50 px-4 py-3 m-2 whitespace-nowrap overflow-ellipsis overflow-hidden flex-auto font-semibold font-roboto bg-blue_four rounded-radius10 ${
                  selectedColor === color
                    ? 'outline-none border border-blue_border'
                    : ''
                } focus:outline-none`}
                style={{minWidth: '60px'}}>
                <span className=" font-medium font-robot">{color}</span>
              </button>
            ))}
          </div>

          <div>
            <div className="mt-6 flex justify-between">
              <button
                className={`cursor-none-allowed text-white h-12 px-3 w-full rounded-lg border-solid border border-gray-400 grid place-items-center focus:outline-none text-center  font-medium primary normal`}
                onClick={buttonHandler}
                disabled={checkColorAvailability}>
                Interested
              </button>
              <button
                className="cursor-none-allowed h-12 px-3 w-full ml-5 rounded-lg border-solid border border-gray-400 border-black grid place-items-center focus:outline-none  text-center bg-grey-200 font-medium secondary normal"
                onClick={ThanksHandler}>
                <span className="text-black">No Thanks</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default SelectColor;
